<template>
  <div class="monitorlog">
    <el-row class="row-title">
      <el-col style="display: flex;">
        <kt-button label="上一天" type="primary" @click="handlePrevDay" />
        <el-date-picker style="margin: 0px 20px;" v-model="dataTime" type="date" placeholder="请选择日期"
          value-format="yyyy-MM-dd" format="yyyy-MM-dd" @change="filterList"></el-date-picker>
        <kt-button label="下一天" type="primary" @click="handleNextDay" />
        <!-- omc/api/downDutyRecordExcel -->
        <el-button
              type="info"
              @click="exportExcel"
              icon="el-icon-download"
              plain>记录导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <!--表格内容栏-->
      <el-table :data="filterColumns" border style="width: 100%; margin-top: 10px" :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="tableHeaderColor">
        <el-table-column prop="date" label="日期" width="120" align="center"></el-table-column>
        <el-table-column prop="hour" label="时间" width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.hour + ":00-" + (Number(scope.row.hour) + 1) + ":00" }}
          </template>
        </el-table-column>
        <el-table-column prop="oldName" label="在院老人" width="100" align="center"></el-table-column>
        <el-table-column prop="remark" label="离院老人" width="100" align="center"></el-table-column>
        <el-table-column prop="userName" label="记录人员" width="100" align="center"></el-table-column>
        <el-table-column prop="serviceName" label="值班人员" min-width="100" align="center"></el-table-column>
        <el-table-column prop="record" label="事件" min-width="200" align="center"></el-table-column>
        <el-table-column :label="monitor.operation" width="180" align="center">
          <template slot-scope="scope">
            <a class="curcor" @click="fixLog(scope.row)">
              <img src="@/assets/beadhouse/xiugai_icon_1.png" />
            </a>
            <a class="curcor" @click="deleList(scope.row)">
              <img src="@/assets/beadhouse/shanchu_icon.png" />
            </a>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 添加班长日志和修改班长日志的dialog模态框-->
    <el-dialog class="monitorLogdialog" :title="operation ? '添加记录' : '修改记录'" width="55%" style="margin-top:-5%"
      :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form :model="dataForm" label-width="100px" :rules="dataFormRules" ref="dataForm" label-position="right">
        <el-row>
          <el-col :span="12">
            <el-form-item label="记录日期:" prop="date">
              <el-date-picker v-model="dataForm.date" type="date" style="width: 100%" :placeholder="monitor.placeChose"
                value-format="yyyy-MM-dd" format="yyyy-MM-dd" disabled></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="记录时间:" prop="date">
              <el-select v-model="dataForm.hour" placeholder="请选择">
                <el-option label="0:00-1:00" value="0" />
                <el-option label="1:00-2:00" value="1" />
                <el-option label="2:00-3:00" value="2" />
                <el-option label="3:00-4:00" value="3" />
                <el-option label="4:00-5:00" value="4" />
                <el-option label="5:00-6:00" value="5" />
                <el-option label="6:00-7:00" value="6" />
                <el-option label="7:00-8:00" value="7" />
                <el-option label="8:00-9:00" value="8" />
                <el-option label="9:00-10:00" value="9" />
                <el-option label="10:00-11:00" value="10" />
                <el-option label="11:00-12:00" value="11" />
                <el-option label="12:00-13:00" value="12" />
                <el-option label="13:00-14:00" value="13" />
                <el-option label="14:00-15:00" value="14" />
                <el-option label="15:00-16:00" value="15" />
                <el-option label="16:00-17:00" value="16" />
                <el-option label="17:00-18:00" value="17" />
                <el-option label="18:00-19:00" value="18" />
                <el-option label="19:00-20:00" value="19" />
                <el-option label="20:00-21:00" value="20" />
                <el-option label="21:00-22:00" value="21" />
                <el-option label="22:00-23:00" value="22" />
                <el-option label="23:00-24:00" value="23" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="在院老人:" prop="oldName">
              <el-input v-model.trim="dataForm.oldName" placeholder maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="离院老人:">
              <el-input v-model.trim="dataForm.remark" placeholder maxlength="32"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="记录人员:" prop="userName">
              <el-input v-model.trim="dataForm.userName" placeholder maxlength="32"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="值班人员:">
              <el-input v-model.trim="dataForm.serviceName" placeholder maxlength="32"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="事件:" prop="record">
          <el-input v-model.trim="dataForm.record" type="textarea" :rows="6" auto-complete="off" placeholder
            style="width: 95%" maxlength="500"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="warning" @click.native="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitForm">确定</el-button>
      </div>
    </el-dialog>
    <el-pagination class="center-pg fenye" ref="pagination" background @current-change="handleCurrentChange"
      :page-size="10" layout="total, prev, pager, next" align="center" :total="totalAll"></el-pagination>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import { baseURL } from "@/utils/request.js";
import util from "@/utils/util.js";
export default {
  name: "MonitorLog",
  components: { KtTable, KtButton },
  data() {
    return {
      monitor: {
        lastDay: "上一天",
        nextDay: "下一天",
        name: "姓名",
        time: "时间",
        place: "地点",
        event: "发生事件",
        reason: "原因",
        handle: "如何处理",
        operation: "操作",
        userName: "负责人",
        addMonitor: "添加班长日志",
        fixMonitor: "修改班长日志",
        placeHolder: "请选择",
        placeChose: "选择时间",
        timeHorizon: "时间范围",
        to: "至",
        timeStart: "开始时间",
        timeOver: "结束时间",
        choseTime: "请选择时间范围",
        place: "地点",
        choseDate: "选择日期"
      }, //引入中文字符
      dataTime: null, //时间
      //dialog的配置
      operation: true,
      dialogVisible: false,
      dataForm: {
        userName: "",
        oldName: "",
        serviceName: "", //当日值班
        date: util.formatDate.format(new Date(), "yyyy-MM-dd"),
        normalRecord: "", //负责人
        unusualRecord: "", //时间范围
        eventRecord: "",
        resolveRecord: "",
        remark: ""
      },
      dataFormRules: {
        oldName: [
          { required: true, message: "不能为空", trigger: "change" }, //是否必填 //规则  //何事件触发
        ],
        userName: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        serviceName: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
      },
      dataFormLoading: false,
      filterColumns: [], //所有数据
      nurseList: [], //护工信息
      oldmanList: [], //老人组
      oldManId: "", //老人id
      nurseid: "", //负责人id
      fixLogid: 0, //修改当前列的id
      pageNum: 1,
      pageSize: 10,
      totalAll: 0, //分页总数
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //上一天
    handlePrevDay() {
      // 获得当前日期
      var doday = new Date(this.dataTime);
      doday = Date.parse(doday);
      // 将当前日期减去1天的时间
      doday = doday - 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.dataTime = nowDate;
      this.findPage();
    },

    //下一天
    handleNextDay() {
      // 获得当前日期
      var doday = new Date(this.dataTime);
      doday = Date.parse(doday);
      // 将当前日期加上1天的时间
      doday = doday + 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.dataTime = nowDate;
      this.findPage();
    },
    //根据时间查询表格数据
    filterList(val) {
      this.dataTime = val;
      this.findPage();
    },
    //翻页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.findPage();
    },
    //表格的添加
    handleAdd() {
      this.dialogVisible = true;
      this.operation = true;
      this.dataForm.date = this.dataTime;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.dataForm.date = this.dataTime;
      });
    },
    /* 
    模糊查询老人
    */
    querySearchAsync(queryString, cb) {
      console.log(queryString, "queryString");
      let param = {
        oldName: this.dataForm.oldName
      };
      this.$postJson("omc/Oldman/showOldManSupAll", param).then((res) => {
        this.oldmanList = res.result.list;
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.dataForm.oldName = "";
          }, 1000);
        }
      });
    },
    /* 
    模糊查询负责人
   */
    querynurse(queryString, cb) {
      let param = {
        userName: queryString
      };
      this.$postJson("uac/emp/queryEmpListWithPage", param).then((res) => {
        this.nurseList = res.result.list;
        var list = [{}];
        if (res.result.list) {
          for (let i of res.result.list) {
            i.value = i.userName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    /* 
      根据负责人获取负责人id
    */
    SelectUser(item) {
      this.userId = item.userId;
      this.dataForm.userName = item.userName;
    },
    SelectNurse(item) {
      this.nurseid = item.userId;
      this.dataForm.nurseName = item.userName;
    },
    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect(item) {
      this.oldManId = item.oldmanId;
    },
    //查询列表
    findPage(data) {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        date: this.dataTime
      };
      this.$postJson("omc/dutylog/showAll", param)
        .then((res) => {
          this.filterColumns = res.result.list;
          this.totalAll = Number(res.result.total);
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .then(data != null ? data.callback : "");
    },
    //导出
    exportExcel() {
      window.location.href =
      baseURL +
      `omc/api/downDutyRecordExcel?groupId=${window.sessionStorage.getItem("groupId")}`;
    },
    // 分页刷新数据
    refreshPageRequest(data) {
      console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage();
    },

    // 新增和编辑提交数据
    submitForm() {
      //校验表单
      if (
        this.dataForm.oldName &&
        this.dataForm.date &&
        this.dataForm.userName &&
        this.dataForm.serviceName
      ) {
        console.log(this.dataForm);
        //校验表单
        // let groupId = sessionStorage.getItem("groupId");
        //提交表单
        let param = {
          date: this.dataForm.date,
          oldName: this.dataForm.oldName,
          userName: this.dataForm.userName,
          serviceName: this.dataForm.serviceName,
          normalRecord: this.dataForm.normalRecord,
          unusualRecord: this.dataForm.unusualRecord,
          eventRecord: this.dataForm.eventRecord,
          resolveRecord: this.dataForm.resolveRecord,
          remark: this.dataForm.remark,
        };
        if (!this.operation) {
          param.id = this.fixLogid;
        }
        this.$postJson(
          this.operation
            ? "omc/dutylog/mLogAdd"
            : "omc/dutylog/updateById",
          param
        ).then((res) => {
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.findPage(); //重新渲染页面
            this.$nextTick(() => {
              this.dialogVisible = false; //关闭弹框
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
      } else {
        this.$message({ message: "必填项不能为空", type: "error" });
      }
    },

    //修改日志
    fixLog(row) {
      console.log(row);
      this.operation = false;
      this.dialogVisible = true;
      this.fixLogid = row.id;

      //数据回显
      this.$nextTick(() => {
        this.nurseid = row.userId;
        this.oldManId = row.oldManId;
        this.dataForm = Object.assign({}, row)
      });
    },

    //删除当前列
    deleList(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: row.id,
          };
          this.$postForm("omc/dutylog/mLogDelById", param).then(
            (res) => {
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.findPage(); //重新渲染页面
              } else {
                this.$message({
                  message: "删除失败, " + res.message,
                  type: "error",
                });
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },

  mounted() {
    this.findPage();
  },
};
</script>
<style lang="scss" scoped>
.monitorlog {
  min-width: 1360px;
  min-height: 500px;
  background: #fefefe;
}

.curcor {
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
}

.resolveitem ::v-deep .el-form-item__label {
  line-height: 25px;
  margin-top: 15px;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

::v-deep .el-dialog .el-dialog__body {
  padding: 20px 20px 10px 20px !important;
}
</style>